import Icon_download from "./Icon_download"
import Spinner from "./Spinner"

const ActionButton = ({ label, onClick, isCaching, isChristmas = true }) => (
  <button
    onClick={() => {
      if (!isCaching) onClick()
    }}
    tabIndex={0}
    css={{
      userSelect: "none",
      display: "flex",
      minHeight: 48,
      width: "100%",
      alignItems: "center",
      gap: 8,
      justifyContent: "center",
      cursor: "pointer",
      borderRadius: 32,
      border: 0,
      outline: "none",
      // backgroundColor: "black",
      transition:
        "transform 150ms ease, box-shadow 150ms ease, filter 150ms ease, opacity 150ms ease, background 150ms ease",

      background:
        "radial-gradient(39.3% 100% at 51.88% 0%, #6684DF 0%, #5E67D7 44.07%, #513CCC 100%), radial-gradient(40.5% 100% at 47.83% 100%, #6684DF 0%, #513CCC 100%)",
      boxShadow:
        "0px -1px 0px 0px rgba(0, 0, 0, 0.20) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.40) inset",
      "&:focus": { outline: "2px solid rgba(35, 8, 113, 0.5)" },
      // keyboard focus visible
      "&:focus-visible": { outline: "3px solid rgba(35, 8, 113, 0.65)" },
      // pointer active (pressed) visual
      "&:active": {
        transform: "translateY(1px) scale(0.99)",
        boxShadow: "0px -1px 0px 0px rgba(0, 0, 0, 0.20) inset",
        filter: "brightness(0.97)",
        opacity: 0.9,
      },

      // Christmas
      ...(isChristmas && {
        background:
          "radial-gradient(48.59% 100% at 51.88% 0%, #F05CA6 6.29%, #D11053 43.06%, #7A0027 100%), radial-gradient(40.5% 100% at 47.83% 100%, #D11053 0%, #7A0027 100%)",
        boxShadow:
          "0 -1px 0 0 #4C0101 inset, 0 1px 0 0 rgba(255, 255, 255, 0.19) inset, 0 0 365.012px 0 #091518",
        "&:hover": {
          filter: "brightness(1.1)",
          boxShadow:
            "0 -1px 0 0 #4C0101 inset, 0 1px 0 0 rgba(255, 255, 255, 0.25) inset, 0 0 200px 0 #E94F93",
        },
        "&:focus-visible": {
          outline: "3px solid rgba(255, 20, 147, 0.6)",
        },
        "&:active": {
          transform: "translateY(1px) scale(0.99)",
          filter: "brightness(0.95)",
          boxShadow:
            "0 -1px 0 0 #4C0101 inset, 0 1px 0 0 rgba(255, 255, 255, 0.12) inset",
        },
      }),

      color: "#FFF",
      textAlign: "center",
      textShadow: "0px 4px 4px rgba(0, 0, 0, 0.16)",
      fontFamily: "Montserrat, sans-serif",
      fontSize: 17,
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "normal",
    }}
  >
    {isCaching ? (
      <Spinner />
    ) : (
      <>
        <Icon_download />
        <div css={{ alignSelf: "stretch", margin: "auto 0" }}>{label}</div>
      </>
    )}
  </button>
)

export default ActionButton
